import React, { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { Col } from "react-bootstrap";
import PatinetHome from "./PatinetHome";

export default function PatientList() {
    return (
        <Fragment>
            <Breadcrumbs mainTitle="List of Customers" parent="Home" title="List of Customers" />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                        <PatinetHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
